import { Injectable } from '@angular/core';
import { coreVendors } from '@nexxe/core-vendors';
import { IContext } from '../interfaces/irequestmetadata';

@Injectable({
	providedIn: 'root'
})
export class CdsDataComposerService {

	private _dataModelService;
	public get dataModelService() {
		return this._dataModelService;
	}
	public set dataModelService(value) {
		this._dataModelService = value;
	}

	private currentContext: IContext

	constructor() { }


	resolveParams(params: any, context?: IContext) {
		if (!params) return params;
		this.currentContext = context;
		const resolvedStringParam = this.resolveParamsHelper(params);
		this.currentContext = undefined;
		return resolvedStringParam || params;
	}

	resolveDataFromStore(path: string) {
		if (!path) return path;
		const segments: string[] = path.split('.');
		if (segments.length === 1) return this._dataModelService.getById(segments[0]);
		return this._dataModelService.getIn(segments[0], segments.slice(1));
	}

	resolveDataFromContext(path: string) {
		if (!path || !this.currentContext) return path;
		const segments: string[] = path.split('.');
		if (segments.length === 1) return this.currentContext[segments[0]];
		return this.resolveNested(segments);
	}

	resolveNested(segments: Array<string>) {
		let nestedContext = this.currentContext;
		coreVendors.lodash.forEach(segments, segment => {
			if (nestedContext[segment] === undefined || nestedContext[segment] === null) {
				throw `The property "${segment}" does not exist on the context passed, at the path provided in the #{path} variable`;
			}
			nestedContext = nestedContext[segment];
		})
		return nestedContext;
	}

	resolveParamsInString(string: string, context?: IContext) {
		if (!string) return string;
		this.currentContext = context;
		const variablesFromStore: string[] = string.match(/\${(.+?)}/g);
		const variablesFromContext: string[] = string.match(/\#{(.+?)}/g)
		let resolvedData;
		coreVendors.lodash.forEach(variablesFromStore, (variable) => {
			resolvedData = this.resolveDataFromStore(this.isStoreVariableType(variable));
			if (resolvedData !== undefined && resolvedData !== null) {
				string = string.replace(variable, resolvedData)
			}
		})
		coreVendors.lodash.forEach(variablesFromContext, (variable) => {
			resolvedData = this.resolveDataFromContext(this.isContextVariableType(variable));
			if (resolvedData !== undefined && resolvedData !== null) {
				string = string.replace(variable, resolvedData)
			}
		})
		this.currentContext = undefined;
		return string;
	}

	resolveParamsHelper(params) {
		if (typeof params === 'string') {
			const storeVarName = this.isStoreVariableType(params);
			if (storeVarName !== null) {
				return this.resolveDataFromStore(storeVarName);
			}
			const contextVarName = this.isContextVariableType(params);
			if (contextVarName !== null) {
				return this.resolveDataFromContext(contextVarName)
			}
			return params
		}
		if (typeof params === 'object') {
			const props = Object.keys(params);
			coreVendors.lodash.forEach(props, prop => {
				if (params[prop]) {
					if (typeof params[prop] === 'string') {
						const storeVarName = this.isStoreVariableType(params[prop]);
						if (storeVarName !== null) {
							params[prop] = this.resolveDataFromStore(storeVarName);
						} else {
							const contextVarName = this.isContextVariableType(params[prop]);
							if (contextVarName !== null) {
								params[prop] = this.resolveDataFromContext(contextVarName);
							}
						}
					} else if (typeof params[prop] === 'object') {
						this.resolveParamsHelper(params[prop]);
					}
				}
			})
		}
	}

	isStoreVariableType(potentialVariableName: string) {
		if (potentialVariableName) {
			const match = potentialVariableName.match(/\${(.*)}/);
			return match && match[1];
		}
	}

	isContextVariableType(potentialVariableName: string) {
		if (potentialVariableName) {
			const match = potentialVariableName.match(/\#{(.*)}/);
			return match && match[1];
		}
	}

}
